import React, { useEffect, useState } from 'react';
import api from '../../_helpers/api';
import axios from 'axios';
import { Loader } from 'rsuite';
import { Card } from 'Components/Common/Card/Card';

export const Emisor = (props) => {
    const { emisor, codigoGeneracion } = props;

    const [catDefsEmi, setCatDefsEmi] = useState({ loading: true });

    const getCATDef_Emi = () => {
        const reqs = [
          api.post(`${api.getUri()}CAT/CAT009`, { code: emisor.tipoEstablecimiento }),
          api.post(`${api.getUri()}CAT/CAT012`, { code: emisor.direccion.departamento }),
          api.post(`${api.getUri()}CAT/CAT013`, { code: emisor.direccion.municipio })
        ]
    
        if(emisor.tipoItemExpor)
          reqs.push(api.post(`${api.getUri()}CAT/CAT011`, { code: emisor.tipoItemExpor.toString() }));
    
        axios.all(reqs).then(
          axios.spread((tipoEstablecimiento, departamento, municipio, tipoItemExpor) => {
            const state = {
              loading: false,
              tipoEstablecimiento: tipoEstablecimiento.data.items.pop(),
              departamento: departamento.data.items.pop(),
              municipio: municipio.data.items.pop(),
            }
    
            if(tipoItemExpor)
              state.tipoItemExpor = tipoItemExpor.data.items.pop();
            
            setCatDefsEmi(state);
          })
        );
      };
      
      useEffect(() => {
        getCATDef_Emi();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [codigoGeneracion]);

  return (
    <Card header={'¿Quién emite el DTE?'}>
      <dl>
        <dt>NIT Emisor</dt>
        <dd>{emisor.nit}</dd>
        <dt>NRC Emisor</dt>
        <dd>{emisor.nrc}</dd>
        <dt>Nombre</dt>
        <dd>{emisor.nombre}</dd>
        {emisor.nombreComercial && (
          <>
            <dt>Nombre Comercial</dt>
            <dd>{emisor.nombreComercial}</dd>
          </>
        )}
        <dt>Tipo de establecimiento</dt>
        <dd>{catDefsEmi.loading ? <Loader /> : `${catDefsEmi.tipoEstablecimiento.code} - ${catDefsEmi.tipoEstablecimiento.value}`}</dd>
        <dt>Dirección</dt>
        <dd>
          {catDefsEmi.loading ? (
            <Loader />
          ) : (
            `${emisor.direccion.complemento}. ${catDefsEmi.departamento.value}, ${catDefsEmi.municipio.value}`
          )}
        </dd>
        <dt>Actividad</dt>
        <dd>
          {emisor.codActividad} - {emisor.descActividad}
        </dd>
        <dt>Teléfono</dt>
        <dd>{emisor.telefono}</dd>
        <dt>Correo</dt>
        <dd>{emisor.correo}</dd>
        {emisor.codEstableMH && (
          <>
            <dt>codEstableMH</dt>
            <dd>{emisor.codEstableMH}</dd>
          </>
        )}
        {emisor.codEstableMH && (
          <>
            <dt>codEstable</dt>
            <dd>{emisor.codEstable}</dd>
          </>
        )}
        {emisor.codEstableMH && (
          <>
            <dt>codPuntoVentaMH</dt>
            <dd>{emisor.codPuntoVentaMH}</dd>
          </>
        )}
        {emisor.codEstableMH && (
          <>
            <dt>codPuntoVenta</dt>
            <dd>{emisor.codPuntoVenta}</dd>
          </>
        )}
        {emisor.tipoItemExpor && (
          <>
            <dt>Tipo de item que está exportando</dt>
            <dd>{catDefsEmi.loading ? <Loader /> : `${catDefsEmi.tipoItemExpor.code} - ${catDefsEmi.tipoItemExpor.value}`}</dd>
          </>
        )}
        {emisor.recintoFiscal && (
          <>
            <dt>Recinto Fiscal</dt>
            <dd>{emisor.recintoFiscal}</dd>
          </>
        )}
        {emisor.regimen && (
          <>
            <dt>Régimen</dt>
            <dd>{emisor.regimen}</dd>
          </>
        )}
      </dl>
    </Card>
  );
};
